import { useState, useEffect } from "react";
import { useMediaQuery, useTheme } from "@mui/material";

const useResponsiveFontSize = () => {
  const theme = useTheme();
  const isTab = useMediaQuery(theme.breakpoints.down("md")); // Default Material-UI breakpoint for medium screens (900px)

  const [fontSize, setFontSize] = useState("1rem");

  useEffect(() => {
    const handleResize = () => {
      setFontSize(isTab ? "0.9rem" : "1rem");
    };

    // Set font size based on initial value
    handleResize();

    // Attach event listener for resizing
    window.addEventListener("resize", handleResize);

    // Cleanup event listener on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [isTab]);

  return fontSize;
};

export { useResponsiveFontSize };
